import { render, staticRenderFns } from "./PerformanceReport.vue?vue&type=template&id=0a268b52&scoped=true"
import script from "./PerformanceReport.vue?vue&type=script&lang=js"
export * from "./PerformanceReport.vue?vue&type=script&lang=js"
import style0 from "./PerformanceReport.vue?vue&type=style&index=0&id=0a268b52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a268b52",
  null
  
)

export default component.exports